import Main from "../admin/main.jsx";

const Admin = () => {
  return <Main />;
};

export default Admin;
